import {Component, ReactNode} from 'react';

export type NavIconName =
    | 'overview'
    | 'conversions'
    | 'usage'
    | 'apiKeys'
    | 'webhooks'
    | 'plan'
    | 'credits'
    | 'invoices'
    | 'history'
    | 'settings';

const PATHS: Record<NavIconName, ReactNode> = {
    overview: (
        <>
            <rect x="2" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <rect x="9" y="2" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <rect x="2" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <rect x="9" y="9" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.4" fill="none" />
        </>
    ),
    conversions: (
        <>
            <path d="M3 4h7M3 8h5M3 12h9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            <path d="M11 10l2 2-2 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" fill="none" />
        </>
    ),
    usage: (
        <>
            <path d="M2 14h12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            <rect x="3" y="9" width="2" height="4" fill="currentColor" />
            <rect x="7" y="6" width="2" height="7" fill="currentColor" />
            <rect x="11" y="4" width="2" height="9" fill="currentColor" />
        </>
    ),
    apiKeys: (
        <>
            <circle cx="5" cy="8" r="3" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M8 8h6M12 8v2M14 8v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
    ),
    webhooks: (
        <>
            <circle cx="4" cy="4" r="1.8" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <circle cx="12" cy="4" r="1.8" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <circle cx="8" cy="12" r="1.8" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M5 5l2 5M11 5l-2 5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
    ),
    plan: (
        <>
            <rect x="2" y="3" width="12" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M2 7h12" stroke="currentColor" strokeWidth="1.4" />
        </>
    ),
    credits: (
        <>
            <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M8 4v8M5 7h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
    ),
    invoices: (
        <>
            <path d="M3 2h7l3 3v9H3z" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinejoin="round" />
            <path d="M5 8h6M5 11h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
    ),
    history: (
        <>
            <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M8 4.5v3.5l2.5 1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </>
    ),
    settings: (
        <>
            <circle cx="8" cy="8" r="2.2" stroke="currentColor" strokeWidth="1.4" fill="none" />
            <path d="M8 2v2M8 12v2M2 8h2M12 8h2M3.5 3.5l1.4 1.4M11.1 11.1l1.4 1.4M3.5 12.5l1.4-1.4M11.1 4.9l1.4-1.4"
                stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </>
    ),
};

interface Props {
    name: NavIconName;
    size?: number;
    className?: string;
}

export class NavIcon extends Component<Props> {
    render() {
        const {name, size = 14, className} = this.props;
        return (
            <svg
                width={size}
                height={size}
                viewBox="0 0 16 16"
                className={className}
                aria-hidden="true"
                style={{flexShrink: 0}}
            >
                {PATHS[name]}
            </svg>
        );
    }
}
